import React, { useState, useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Navigate, useParams, Link } from 'react-router-dom'
import { API_ENDPOINTS } from '../config/api'
import { Button, Alert } from '../components/ui'

const SurveyPreviewPage: React.FC = () => {
  const { surveyId = '' } = useParams<{ surveyId: string }>()
  const intl = useIntl()
  const [publicId, setPublicId] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const fetchSurvey = async () => {
      try {
        const token = localStorage.getItem('access_token')
        const response = await fetch(API_ENDPOINTS.surveys.byId(surveyId), {
          headers: {
            'Authorization': token ? `Bearer ${token}` : ''
          }
        })
        if (response.ok) {
          const data = await response.json()
          setPublicId(data.public_id)
        } else {
          setError(intl.formatMessage({ id: 'preview.error.notFound' }))
        }
      } catch (err) {
        console.error('Error fetching survey:', err)
        setError(intl.formatMessage({ id: 'preview.error.loadFailed' }))
      } finally {
        setLoading(false)
      }
    }
    fetchSurvey()
  }, [surveyId])

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-foreground-muted"><FormattedMessage id="preview.loading" /></div>
      </div>
    )
  }

  if (error || !publicId) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <Alert variant="error" className="mb-4">{error || intl.formatMessage({ id: 'preview.error.notFound' })}</Alert>
          <Link to="/dashboard">
            <Button variant="primary"><FormattedMessage id="preview.backToDashboard" /></Button>
          </Link>
        </div>
      </div>
    )
  }

  return <Navigate to={`/survey/${publicId}?preview=true`} replace />
}

export default SurveyPreviewPage
